import { render, staticRenderFns } from "./ForeignerForm.vue?vue&type=template&id=48539810&"
import script from "./ForeignerForm.vue?vue&type=script&lang=js&"
export * from "./ForeignerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports